import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { StatusBanner } from '@/components/common/States';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

const Pinned = styled.div`
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.sticky};
  padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[4]};
`;

export default function OfflineBanner() {
  const online = useOnlineStatus();
  const { t } = useTranslation();

  if (online) return null;

  return (
    <Pinned data-no-print>
      <StatusBanner intent="warning" title={t('states.offline.title')}>
        {t('states.offline.body')}
      </StatusBanner>
    </Pinned>
  );
}
